import React, {
    useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import { useLocation, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import ReactPlayer from 'react-player';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import _ from 'lodash';
import GridItem from '../../components/Grid/GridItem';
import GridContainer from '../../components/Grid/GridContainer';
import WrapperContainer from '../../components/Container/WrapperContainer';
import CustomTypography from '../../components/Typography/CustomTypography';
import DetailSeminarStyle from '../../assets/jss/pages/detailSeminarCompanyStyle';
import Loader from '../../components/Loader/Loader';
import ViewHeader from '../../components/Header/ViewHeader';
import Button from '../../components/Button/CustomButton';
import Snackbar from '../../components/Snackbar/Snackbar';

export const Header = (props) => {
    const { eventInfo } = props;
    const intl = useIntl();
    return (
        <>
            {!_.isEmpty(eventInfo) && (
                <ViewHeader
                    eventName={eventInfo.name}
                    title={eventInfo?.settings_texts_sidebar_viewer?.field_name?.livestream_application_list || intl.formatMessage({ id: 'userRoutes.liveStreamRegister' })}
                    isIntl={false}
                    eventInfo={eventInfo}
                />
            )}
        </>
    );
};

Header.defaultProps = {
    eventInfo: {},
};

Header.propTypes = {
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
};

const useStyles = makeStyles(DetailSeminarStyle);

const DetailLivestreamRegistered = ({
    isLoading,
    detailEvent,
    fetchClearDetailLiveStream,
    fetchGetDetailLiveStream,
    customText,
    customColor,
    eventInfo,
    getDetailLiveStream,
    fetchClearDetailLiveStreamEvent,
    getCustomText,
    clearCustomText,
    detailEventView,
    locale,
}) => {
    const classes = useStyles(customColor);
    const intl = useIntl();
    const [params, setParams] = useState({});
    const [dates, setDates] = useState('');
    const routeParams = useParams();
    const { shortName } = useParams();
    const queryString = new URLSearchParams(useLocation().search);
    const isPreview = queryString.get('is_preview');
    const [snackbar, setSnackbar] = useState({ isOpen: false, type: 'success', message: '' });

    useEffect(() => {
        fetchClearDetailLiveStream();
        clearCustomText();
        return () => {
            if (isPreview) {
                fetchClearDetailLiveStreamEvent();
                clearCustomText();
            } else {
                fetchClearDetailLiveStream();
            }
        };
    }, []);

    useEffect(() => {
        if (shortName) {
            if (isPreview) {
                getCustomText({
                    eventShortName: shortName,
                    site: 0,
                    text_type: 0,
                    language: locale,
                });
                getDetailLiveStream({
                    event_name: shortName,
                    live_stream_id: routeParams.id,
                    language: locale,
                });
            } else {
                fetchGetDetailLiveStream({
                    event_name: routeParams.shortName,
                    live_stream_id: routeParams.id,
                    language: locale,
                });
            }
        }
    }, [shortName, locale]);

    useEffect(() => {
        if (isPreview) {
            setParams({ ...detailEvent });
        } else {
            setParams({ ...detailEventView });
        }
    }, [detailEvent, detailEventView]);

    useEffect(() => {
        if (!_.isEmpty(params) && isPreview) {
            setDates(params.dates[0].date);
        }
    }, [isPreview, params]);

    const customVideoLiveStream = (url) => {
        const srcVideo = url.indexOf('src');
        const startSrc = url.indexOf('"', srcVideo);
        const endSrc = url.indexOf('"', startSrc + 1);

        return url.slice(startSrc + 1, endSrc);
    };
    const isIframe = (url) => {
        if (new RegExp(/(?:<iframe[^>]*)(?:(?:\/>)|(?:>.*?<\/iframe>))/g).test(url)) {
            return true;
        }
        return false;
    };

    const renderButton = (title, href, target) => (
        <Button
            color="navy"
            gradient
            size="sm"
            round
            className={classes.btnStyle}
            href={!isPreview && href}
            onClick={isPreview && handleSnackbar}
            target={target}
            buttonTextColor={customColor?.button_text_color}
            buttonBackgroundColor={customColor?.button_background_color?.common_button}
        >
            {title}
        </Button>
    );

    const handleSnackbar = () => {
        if (isPreview) {
            setSnackbar({
                ...snackbar,
                isOpen: true,
                type: 'error',
                message: intl.formatMessage({ id: 'common.noPreview' }),
            });
        }
    };

    return (
        <>
            <Loader isLoading={isLoading} />
            {!_.isEmpty(eventInfo) && (
                <WrapperContainer xs={12} md={12} className={classes.wrapper}>
                    <GridItem md={12} className={classes.leftContent}>
                        <GridContainer className={classes.spacingViewer}>
                            <GridItem xs={12} sm={3} md={3}>
                                <CustomTypography bold customColor={customColor?.contents_text_color}>
                                    {customText?.field_name?.title || intl.formatMessage({ id: 'common.title' })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={9}>
                                <CustomTypography customColor={customColor?.contents_text_color}>
                                    {params.title}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacingViewer}>
                            <GridItem xs={12} sm={3} md={3}>
                                <CustomTypography bold customColor={customColor?.contents_text_color}>
                                    {customText?.field_name?.performer || intl.formatMessage({ id: 'common.performer' })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={9}>
                                <CustomTypography customColor={customColor?.contents_text_color}>
                                    {params.speaker}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacingViewer}>
                            <GridItem xs={12} sm={3} md={3}>
                                <CustomTypography bold customColor={customColor?.contents_text_color}>
                                    {customText?.field_name?.delivery_time || intl.formatMessage({ id: 'livestream.deliveryTime' })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={9}>
                                <CustomTypography customColor={customColor?.contents_text_color}>
                                    {params.stime}
                                    {' '}
                                    ~
                                    {' '}
                                    {params.etime}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacingViewer}>
                            <GridItem xs={12} sm={3} md={3}>
                                <CustomTypography bold customColor={customColor?.contents_text_color}>
                                    {customText?.field_name?.date_livestream || intl.formatMessage({ id: 'common.schedule' })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={9}>
                                {isPreview ? (
                                    <CustomTypography customColor={customColor?.contents_text_color}>
                                        { [(dates || '').slice(0, 4), '/', (dates || '').slice(5, 7), '/', (dates || '').slice(8, 10)].join('') }
                                    </CustomTypography>
                                ) : (
                                    <CustomTypography customColor={customColor?.contents_text_color}>
                                        { [(params.date || '').slice(0, 4), '/', (params.date || '').slice(5, 7), '/', (params.date || '').slice(8, 10)].join('') }
                                    </CustomTypography>
                                )}
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacingViewer}>
                            <GridItem xs={12} sm={3} md={3}>
                                <CustomTypography bold customColor={customColor?.contents_text_color}>
                                    {customText?.field_name?.contents || intl.formatMessage({ id: 'livestream.deliveryContent' })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={9}>
                                <CustomTypography customColor={customColor?.contents_text_color}>
                                    {params.content}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        {locale === 'ja' && (
                            <GridContainer className={classes.spacingViewer}>
                                <GridItem xs={12} sm={3} md={3}>
                                    <CustomTypography bold customColor={customColor?.contents_text_color}>
                                        {customText?.field_name?.performer_profile || intl.formatMessage({ id: 'livestream.performerProfile' })}
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} sm={9} md={9}>
                                    <CustomTypography customColor={customColor?.contents_text_color}>
                                        {params.streamer_profile}
                                    </CustomTypography>
                                </GridItem>
                            </GridContainer>
                        )}
                        <GridContainer className={classes.spacingViewer}>
                            <GridItem xs={12} sm={3} md={3}>
                                <CustomTypography bold customColor={customColor?.contents_text_color}>
                                    {customText?.field_name?.fee || intl.formatMessage({ id: 'price' })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={9} md={9}>
                                <CustomTypography customColor={customColor?.contents_text_color}>
                                    {params.cost > 0
                                        ? `${intl.formatNumber(params.cost)}${intl.formatMessage({ id: 'common.yen' })}`
                                        : intl.formatMessage({ id: 'common.free' })}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        {
                            params.url_live_stream && (
                                <GridItem xs={12} md={10} className={classes.sliderFirst}>
                                    <div
                                        style={{
                                            marginTop: '20px',
                                            paddingLeft: '24%',
                                            width: '100%',
                                        }}
                                    >
                                        {isIframe(params.url_live_stream) ? (
                                            <iframe
                                                title="view live stream"
                                                src={customVideoLiveStream(params.url_live_stream)}
                                                frameBorder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowFullScreen
                                                outline="none"
                                                margin="auto"
                                                height="450px"
                                                width="100%"
                                            />
                                        ) : (
                                            <ReactPlayer
                                                controls
                                                config={{
                                                    attributes: {
                                                        controlsList: 'nodownload',
                                                        style: {
                                                            outline: 'none',
                                                            margin: 'auto',
                                                            maxHeight: '450px',
                                                            maxWidth: '100%',
                                                        },
                                                    },
                                                }}
                                                height="450px"
                                                url={params.url_live_stream}
                                                style={{ display: 'flex', margin: 'auto' }}
                                            />
                                        )}
                                    </div>
                                </GridItem>
                            )
                        }
                        {
                            !params.url_live_stream && (
                                <GridContainer className={classes.spacingViewer}>
                                    <GridItem xs={12} sm={9} md={9}>
                                        <CustomTypography bold style={{ marginTop: '20px' }} customColor={customColor?.contents_text_color}>
                                            {intl.formatMessage({ id: 'livestream.noViewLivestream' }, {
                                                namePage: eventInfo.settings_texts_sidebar_viewer?.field_name?.livestreaming || intl.formatMessage({ id: 'userRouters.liveStream' }),
                                            })}
                                        </CustomTypography>
                                    </GridItem>
                                </GridContainer>
                            )
                        }
                        <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap" width="100%">
                            { params.document_link && renderButton(
                                customText?.button_name?.document_link || intl.formatMessage({ id: 'productRegister.documentRequestReception' }),
                                params.document_link, '_blank',
                            )}
                            { params.document && renderButton(
                                customText?.button_name?.document || intl.formatMessage({ id: 'exhibition.documentDownload' }),
                                params.document, '_blank',
                            )}
                            { params.inquiry
                                    && renderButton(
                                        customText?.button_name?.inquiry || intl.formatMessage({ id: 'organizerBusinessContact.inquiries' }),
                                        `https://mail.google.com/mail/?view=cm&fs=1&to=${params.inquiry}`, '_blank',
                                    )}
                            { params.survey_link && renderButton(
                                customText?.button_name?.survey_link || intl.formatMessage({ id: 'productRegister.survey' }),
                                params.survey_link, '_blank',
                            )}
                        </Box>
                    </GridItem>
                    <Snackbar
                        open={snackbar.isOpen}
                        onClose={() => setSnackbar({ ...snackbar, isOpen: false })}
                        message={snackbar.message}
                        severity={snackbar.type}
                        autoHideDuration={1000}
                    />
                </WrapperContainer>
            )}
        </>
    );
};

DetailLivestreamRegistered.defaultProps = {
    detailEvent: {},
    customText: {},
    customColor: {},
    eventInfo: {},
    getCustomText: () => {},
    clearCustomText: () => {},
    detailEventView: {},
    locale: 'ja',
};

DetailLivestreamRegistered.propTypes = {
    fetchGetDetailLiveStream: PropTypes.func.isRequired,
    fetchClearDetailLiveStream: PropTypes.func.isRequired,
    detailEvent: PropTypes.oneOfType([() => null, PropTypes.object]),
    isLoading: PropTypes.bool.isRequired,
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    getDetailLiveStream: PropTypes.func.isRequired,
    fetchClearDetailLiveStreamEvent: PropTypes.func.isRequired,
    getCustomText: PropTypes.func,
    clearCustomText: PropTypes.func,
    detailEventView: PropTypes.oneOfType([() => null, PropTypes.object]),
    locale: PropTypes.string,
};

export default DetailLivestreamRegistered;
